export default "__VITE_ASSET__Iexp8o67__"